import { render } from "./NFTDetail.vue?vue&type=template&id=80e73454&scoped=true"
import script from "./NFTDetail.vue?vue&type=script&lang=js"
export * from "./NFTDetail.vue?vue&type=script&lang=js"

import "./NFTDetail.vue?vue&type=style&index=0&id=80e73454&lang=less&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80e73454"]])

export default __exports__